export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/g;
export const encryptionKey = 'ABCDEF1900@!123qweasd.';
export const DefaultCountryDivisionID = 28367; // مشهد ثامن
export const DefaultProvince = 9; // خراسان رضوی
export const SupplyLastUpdate = 'supply-last-update'
export const SupplyLastUpdateWarning = 'supply-last-update-warning'
export const SupplyLastUpdateWarningDate = 'supply-last-update-warning-date'
export const DefaultLat = 35.7
export const DefaultLng = 51.2
